import { Controller } from "@hotwired/stimulus"

// Lives on the role-mask strip, so it's active exactly while a mask is on.
// Wraps window.fetch once: whenever the server refuses a write with the
// X-Role-Mask-Blocked marker, the SAME red "read only" toast appears —
// regardless of how (or whether) the page's own JS reports the failure.
export default class extends Controller {
  static values = { message: String }

  connect() {
    window.__roleMaskGuardMessage = this.messageValue
    if (window.__roleMaskGuardInstalled) return
    window.__roleMaskGuardInstalled = true

    const originalFetch = window.fetch.bind(window)
    window.fetch = async (...args) => {
      const resp = await originalFetch(...args)
      try {
        if (resp?.headers?.get("X-Role-Mask-Blocked")) this._showReadOnlyToast()
      } catch {
        // Never let the guard break the caller.
      }
      return resp
    }
  }

  _showReadOnlyToast() {
    // One toast per burst — a single click can fire several requests.
    const now = Date.now()
    if (now - (window.__roleMaskGuardLastToast || 0) < 1500) return
    window.__roleMaskGuardLastToast = now

    const el = document.createElement("div")
    el.className = "flash-toast-alert"
    el.style.zIndex = "9999"
    el.setAttribute("data-controller", "flash")
    el.setAttribute("data-flash-dismiss-after-value", "5000")
    el.setAttribute("role", "alert")
    const iconDiv = document.createElement("div")
    iconDiv.className = "shrink-0"
    iconDiv.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"/></svg>'
    const msgP = document.createElement("p")
    msgP.className = "flex-1 text-sm"
    msgP.textContent = window.__roleMaskGuardMessage || "Read only while masked."
    el.appendChild(iconDiv)
    el.appendChild(msgP)
    document.body.prepend(el)
  }
}
